import React from 'react';
import ReactDOM from 'react-dom/client';
import { AdminApp } from './AdminApp';
import './admin.css';
import './admin-polish.css'; // 追加式润色层（手机端断点 / 焦点环 / 吸顶顶栏）

ReactDOM.createRoot(document.getElementById('admin-root') as HTMLElement).render(
  <React.StrictMode>
    <AdminApp />
  </React.StrictMode>
);
